module.exports = __webpack_public_path__ + "static/media/logo_wbs_training.a2f27a4e.svg";